module.exports = __webpack_public_path__ + "img/bj7.6a972f7c.png";